/**
 * 黄江 on 2017/7/23
 * 描述：
 */
import axios from 'axios'
import router from '@/router'
axios.defaults.withCredentials = true
const apiHost = {
  name:'build',
  dev:'http://127.0.0.1:8082',
  build:'http://apizz.oklok.com.cn',
  type:'org',
}
const ApiMixin = {
  handleCatchError(err) {
  },
  getHost(){
    return apiHost[apiHost.name]
  },
  getUploadUrl(){
    return `${apiHost[apiHost.name]}/org/base/upload`
  },
  async getCodeService(param) {
    try {
      const res = await axios.get(`${apiHost[apiHost.name]}/${apiHost.type}/base/getCode/2`, param)
      return res.data
    }
    catch (err) {
      this.handleCatchError(err)
      return err
    }
  },
  async loginService(param) {
    try {
      const res = await axios.post(`${apiHost[apiHost.name]}/${apiHost.type}/login`, param)
      return res.data
    }
    catch (err) {
      this.handleCatchError(err)
      return err
    }
  },
  async editPwordService(param) {
    try {
      const res = await axios.post(`${apiHost[apiHost.name]}/${apiHost.type}/user/editPword`, param)
      return res.data
    }
    catch (err) {
      this.handleCatchError(err)
      return err
    }
  },
  async getUsers(param) {
    try {
      const res = await axios.post(`${apiHost[apiHost.name]}/${apiHost.type}/user/list`, param)
      return res.data
    }
    catch (err) {
      this.handleCatchError(err)
      return err
    }
  },
  async addUser(param) {
    try {
      const res = await axios.post(`${apiHost[apiHost.name]}/${apiHost.type}/user/add`, param)
      return res.data
    }
    catch (err) {
      this.handleCatchError(err)
      return err
    }
  },
  async postService(moduleName,param) {
    try {
      const token = sessionStorage.getItem('token')
      const res = await axios.post(`${apiHost[apiHost.name]}/${apiHost.type}/${moduleName}`, param,{headers:{token}})
      if(res.data.code==-999){
        router.push('/login')
        return
      }
      return res.data
    }
    catch (err) {
      this.handleCatchError(err)
      return err
    }
  },
  async getListService(moduleName,param) {
    try {
      const token = sessionStorage.getItem('token')
      const res = await axios.post(`${apiHost[apiHost.name]}/${apiHost.type}/${moduleName}/list`, param, {headers:{token}})
      if(res.data.code==-999){
        router.push('/login')
        return
      }
      return res.data
    }
    catch (err) {
      this.handleCatchError(err)
      return err
    }
  },
  async getDetailService(moduleName,param) {
    try {
      const token = sessionStorage.getItem('token')
      const res = await axios.post(`${apiHost[apiHost.name]}/${apiHost.type}/${moduleName}/detail`, param, {headers:{token}})
      if(res.data.code==-999){
        router.push('/login')
        return
      }
      return res.data
    }
    catch (err) {
      this.handleCatchError(err)
      return err
    }
  },
  async addService(moduleName,param) {
    try {
      const token = sessionStorage.getItem('token')
      const res = await axios.post(`${apiHost[apiHost.name]}/${apiHost.type}/${moduleName}/add`, param, {headers:{token}})
      if(res.data.code==-999){
        router.push('/login')
        return
      }
      return res.data

    }
    catch (err) {
      this.handleCatchError(err)
      return err
    }
  },
  async editService(moduleName,param) {
    try {
      const token = sessionStorage.getItem('token')
      const res = await axios.post(`${apiHost[apiHost.name]}/${apiHost.type}/${moduleName}/edit`, param, {headers:{token}})
      if(res.data.code==-999){
        router.push('/login')
        return
      }
      return res.data

    }
    catch (err) {
      this.handleCatchError(err)
      return err
    }
  },
  async delMoreService(moduleName,param) {
      try {
        const token = sessionStorage.getItem('token')
        const res = await axios.post(`${apiHost[apiHost.name]}/${apiHost.type}/${moduleName}/delMore`, param, {headers:{token}})
        if(res.data.code==-999){
          router.push('/login')
          return
        }
        return res.data
      }
      catch (err) {
          this.handleCatchError(err)
          return err
      }
  },
}
export default {
  methods: ApiMixin,
}



// WEBPACK FOOTER //
// ./src/assets/js/apis.js